<template>
<div>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form>
            <el-form-item>
                <el-input placeholder="输卡号/查询码/代理商名" v-model="info" style="width:200px"></el-input>
                <el-date-picker type="date" v-model="startDate" placeholder="开始日期">
                </el-date-picker>
                <el-date-picker type="date" placeholder="结束日期" v-model="endDate">
                </el-date-picker>
                <el-button type="primary" @click="searchDate()">查询</el-button>
                <el-button type="primary" @click="exportTable()">导出EXCEL</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <el-table :data="tableData" border v-loading="listLoading" style="width: 100%;margin-top:5px;">
        <el-table-column sortable prop="orderid" label="充值单据号" min-width="150">
        </el-table-column>
        <el-table-column prop="packtype" label="套餐类别" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="packname" label="套餐名称" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="msisdn" label="卡号" min-width="150" sortable>
        </el-table-column>
        <!--
      <el-table-column prop="querycode" label="查询代码" min-width="150" sortable>
      </el-table-column>
      <el-table-column prop="iccid" label="ICCID" min-width="220" sortable>
      </el-table-column>
      -->
        <el-table-column prop="money" label="充值金额(元)" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="ordertimestr" label="充值时间" min-width="180" sortable>
        </el-table-column>
        <el-table-column prop="serviceusername" label="代理商名称" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="remark" label="充值备注" min-width="150" sortable>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="80">
            <template scope="scope">
                <el-button @click="handleClick(scope.$index, scope.row)" size="small">查看</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar" style="text-align:right">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </el-col>

    <el-dialog title="充值详细" :visible.sync="userInfoFormVisible" :close-on-click-modal="true">
        <div style="overflow: auto; width: 100%;">
            <table class="border-table">
                <tr>
                    <td class="spec alt">充值单据号:</td>
                    <td>{{orderInfo.orderid}}</td>
                    <td class="alt spec">套餐类别:</td>
                    <td>{{orderInfo.packtype}}</td>
                </tr>
                <tr>
                    <td class="spec alt">套餐名称:</td>
                    <td>{{orderInfo.packname}}</td>
                    <td class="alt spec">卡号:</td>
                    <td>{{orderInfo.msisdn}}</td>
                </tr>
                <tr>
                    <td class="alt alt">查询代码:</td>
                    <td>{{orderInfo.querycode}}</td>
                    <td class="spec alt">ICCID:</td>
                    <td>{{orderInfo.iccid}}</td>
                </tr>
                <tr>
                    <td class="alt spec">支付金额:</td>
                    <td>{{orderInfo.money}}元</td>
                    <td class="alt spec">套餐费用:</td>
                    <td>{{orderInfo.rechargePrice}}元</td>
                </tr>
                 <tr>
                    <td class="spec alt">实际欠费:</td>
                    <td>{{orderInfo.arreasPrice}}元</td>
                    <td class="spec alt">欠费补缴:</td>
                    <td>{{orderInfo.arreas}}元</td>
                </tr>
                <tr>
                    <td class="spec alt">充值来源:</td>
                    <td>{{orderInfo.rechargeSource}}</td>
                    <td class="spec alt">充值前到期时间:</td>
                    <td>{{orderInfo.expireTime}}</td>
                </tr>
                <tr>
                    <td class="spec alt">充值后到期时间:</td>
                    <td>{{orderInfo.rechargeExpireTime}}</td>
                     <td class="spec alt">充值备注:</td>
                    <td>{{orderInfo.remark}}</td>
                </tr>
                <tr>
                    <td class="spec alt">代理商名称:</td>
                    <td>{{orderInfo.serviceusername}}</td>
                    <td class="alt spec">订单时间:</td>
                    <td>{{orderInfo.ordertimestr}}</td>
                   
                </tr>
                <tr v-if="orderInfo.packtype == '叠加卡'">
                    <td class="spec alt">流量包大小:</td>
                    <td>{{orderInfo.addgprssize}}M</td>
                    <td class="alt spec">流量包价格:</td>
                    <td>{{orderInfo.addgprsprice}}元</td>
                </tr>
                <tr v-if="orderInfo.packtype == '叠加卡'">
                    <td class="spec alt">购买数量:</td>
                    <td>{{orderInfo.addgprscount}}</td>
                </tr>
            </table>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {
    getOrderList
} from '../../api/api'
import util from '../../common/js/util'

export default {

    data() {
        return {
            checkIfo: false,
            info: '', //查询代码
            startDate: '',
            endDate: '',
            userInfoFormVisible: false, //弹窗的关闭状态
            currentPage: 1, //当前页
            total: 1, //数据条数
            pageSize: 10,
            listLoading: false,
            orderInfo: {
                //充值记录实体信息
                orderid: '',
                packtype: '',
                packname: '',
                msisdn: 0,
                querycode: '',
                iccid: '',
                money: 35,
                ordertimestr: '',
                serviceusername: '',
                remark: '',
                arreas: '',
                arreasPrice:'',
                rechargeExpireTime: '',
                expireTime: '',
                rechargeSource:"",
                rechargePrice:""
            },
            tableData: [], //表格

        }
    },
    mounted() {
        this.getlist();
    },

    methods: {
        handleClick(index, row) {
            //修改充值记录
            this.orderInfo.orderid = row.orderid;
            this.orderInfo.iccid = row.iccid;
            this.orderInfo.packtype = row.packtype;
            this.orderInfo.packname = row.packname;
            this.orderInfo.msisdn = row.msisdn;
            this.orderInfo.querycode = row.querycode;
            this.orderInfo.money = row.money;
            this.orderInfo.ordertimestr = row.ordertimestr;
            this.orderInfo.serviceusername = row.serviceusername;
            this.orderInfo.remark = row.remark;
            this.orderInfo.arreas = row.arreas;
            if(null == row.expireTime || "null" == row.expireTime || "" == row.expireTime ){
                this.orderInfo.expireTime = "";
            }else{
                    this.orderInfo.expireTime = row.expireTime.substring(0,10);
            }
            this.orderInfo.arreasPrice = row.arreasPrice;
            if(null == row.rechargeExpireTime || "null" == row.rechargeExpireTime || "" == row.rechargeExpireTime){
                this.orderInfo.rechargeExpireTime = "";
            }else{
                   this.orderInfo.rechargeExpireTime = row.rechargeExpireTime.substring(0,10);
            }
            this.orderInfo.rechargePrice = row.rechargePrice;
            if("1" == row.isbath){
                this.orderInfo.rechargeSource = "批量充值";
            }else{
                 this.orderInfo.rechargeSource = "客户扫码充值";
            }
            if(row.packtype == '叠加卡'){
                this.orderInfo.addgprssize = row.addgprssize;
                this.orderInfo.addgprsprice = row.addgprsprice;
                this.orderInfo.addgprscount = row.addgprscount;
            }
            //打开弹窗
            this.userInfoFormVisible = true;
        },
        search() {
            //过滤查询
            if (this.startDate > this.endDate) {
                this.$message({
                    message: '开始时间不能大于结束时间',
                    type: 'warning'
                });
                this.checkIfo = false;
                this.startDate = "";
                this.endDate = "";
            }
            if ((this.startDate !== "" && this.endDate !== "") || (this.startDate == "" && this.endDate == "")) {
                this.checkIfo = true;
            } else {
                this.$message({
                    message: '选择日期区间时不能有空值',
                    type: 'warning'
                });
                this.startDate = "";
                this.endDate = "";
                this.checkIfo = false;
            }
        },
        searchDate() {
            //if(this.checkIfo){
            this.currentPage=1;
            this.getlist();
            // }else{
            //   this.search();
            // }
        },
        //分页查询数据
        getlist() {

            this.startDate = (!this.startDate || this.startDate == '') ? '' : util.formatDate.format(new Date(this.startDate), 'yyyy-MM-dd');
            this.endDate = (!this.endDate || this.endDate == '') ? '' : util.formatDate.format(new Date(this.endDate), 'yyyy-MM-dd');

            let para = {
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                info: this.info,
                startDate: this.startDate,
                endDate: this.endDate
            };
            this.listLoading = true;
            getOrderList(para).then((res) => {
                this.tableData = res.data.list;
                this.total = res.data.total;
                this.listLoading = false;
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getlist();
        },
        handleCurrentChange(val) {
            //换页查询数据
            this.search();
            this.currentPage = val;
            this.getlist();
        },
        exportTable() {
            this.startDate = (!this.startDate || this.startDate == '') ? '' : util.formatDate.format(new Date(this.startDate), 'yyyy-MM-dd');
            this.endDate = (!this.endDate || this.endDate == '') ? '' : util.formatDate.format(new Date(this.endDate), 'yyyy-MM-dd');
            let para = "";
            para += "info=" + ((!this.info || this.info == '') ? '' : this.info);
            para += "&startDate=" + ((!this.startDate || this.startDate == '') ? '' : this.startDate);
            para += "&endDate=" + ((!this.endDate || this.endDate == '') ? '' : this.endDate);
            location.href = "/api/recharge/exportXls?" + para;
        }
    }
}
</script>
<

<style>
.border-table {
    border-collapse: collapse;
    border: none;
    width: 100%;
}

.border-table td {
    border: solid #dfe8ec 1px;
    background: #fff;
    font-size: 14px;
    padding: 12px 1px 12px 12px;
    color: #009966;
    line-height: 28px;
}

td.alt {
    background: #EFF2F7;
    color: #8492A6;
}

.alt {
    width: 100px;
}
</style>



// WEBPACK FOOTER //
// money_query.vue?1d3c8dbc